import React from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { PaginationControl, PaginationLink } from '../styles';

var PreviousButton = function PreviousButton(_ref) {
  var currentPage = _ref.currentPage,
      onChangePage = _ref.onChangePage,
      pageUrls = _ref.pageUrls;
  // setting this to undefined (aka on page 0 when this button is hidden) for some reason
  // breaks the href on the other pages where the button is actually visible
  var page = Math.max(currentPage - 1, 0);
  return /*#__PURE__*/React.createElement(PaginationControl, {
    isHidden: currentPage === 0
  }, /*#__PURE__*/React.createElement(PaginationLink, {
    hasButtonBehavior: true,
    href: pageUrls[page],
    onClick: function onClick(e) {
      onChangePage(page, e);
    },
    "aria-label": "previous page",
    "data-test": "pagination-prev"
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    size: "xsmall",
    pointing: "left"
  }), "Prev"));
};

PreviousButton.displayName = 'PreviousButton';
export default PreviousButton;